import styled, { keyframes, css } from 'styled-components';

const ContentSlide = keyframes`
  100% { right: 0; }
`;

export const Wrapper = styled.div`
  width: 1250px;
  height: 100%;
  display: flex;
  flex-flow: column;
  position: fixed;
  top: 0;
  right: -860px;
  z-index: 5;
  animation: ${ContentSlide} 0.4s forwards;
  background: white;
`;

export const Overlay = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  width: 100%;
  height: 100%;
  position: fixed;
  cursor: default;
  background: rgba(0, 0, 0, 0.56);
`;
